import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { Extraction } from "../../../api/knowledgeData/knowledgeDataDecoders";
import { requestBlob } from "../../../api/http/httpClient";
import ErrorNotice from "../../../errors/ErrorNotice";
import { toUiError, type UiError } from "../../../errors/uiError";
import { wholeGraph } from "./aboxViewModel";
import SourceView from "../../../ui/content/source/SourceView";
import AppButton from "../../../ui/buttons/AppButton";

export default function ABoxTechnicalDetails({ extraction }: { extraction: Pick<Extraction, "instanceStatements"> & Partial<Pick<Extraction, "threadId" | "outputEntry">> }) {
  const { t } = useTranslation();
  const [error, setError] = useState<UiError | null>(null);
  const [busy, setBusy] = useState(false);
  const download = async () => {
    if (extraction.threadId === undefined || extraction.outputEntry === undefined) return;
    setBusy(true);
    setError(null);
    try {
      const response = await requestBlob({ method: "GET", path: `/id/extractions/${encodeURIComponent(extraction.threadId)}/${String(extraction.outputEntry)}`, resolver: true, accept: "application/n-quads" });
      const url = URL.createObjectURL(response);
      const link = document.createElement("a");
      link.href = url;
      link.download = `extraction-${extraction.outputEntry}.nq`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (caught) {
      setError(toUiError(caught));
    } finally {
      setBusy(false);
    }
  };
  return (
    <details>
      <summary className="app-link cursor-pointer text-sm">{t("data.abox.technical")}</summary>
      <SourceView label={t("data.abox.technical")} language="turtle" value={wholeGraph(extraction.instanceStatements)} className="my-2" />
      {extraction.threadId === undefined || extraction.outputEntry === undefined ? null : <AppButton variant="secondary" size="sm" disabled={busy} onClick={() => { void download(); }}>{t("data.abox.download")}</AppButton>}
      {error === null ? null : <ErrorNotice error={error} />}
    </details>
  );
}
